(function($, _window, _body) {
	_window.on('elementor/frontend/init', function() {
		elementorFrontend.hooks.addAction('frontend/element_ready/theme-video-carousel.default', function($scope, $s) {
			var tpl = _.template($('#theme-video-carousel-tpl')
				.html());
			var slideContainer = $('.slides', $scope);
			var setting = JSON.parse($('.theme-widget-element', $scope)
				.attr('data-setting'));
			var appliedFilter = $.extend({}, {
				page: 1,
				per_page: setting.per_page,
			}, setting.activeFilter);
			var initSlide = function() {
				$scope.imagesLoaded(function() {
					slideContainer.owlCarousel({
						items: 1,
						nav: false,
						dots: false,
						navText: [theme.svg_icon('nav-prev'), theme.svg_icon('nav-next')],
						responsive: {
							1080: {
								nav: true,
							},
						},
					});
				});
			};
			$.getJSON(setting.rest, appliedFilter, function(data) {
				var html = $(tpl(data));
				slideContainer.append(html);
				initSlide();
			});
		});
	});
})(jQuery, jQuery(window), jQuery('body'));